import { cn } from '@/lib/cn'

/**
 * Score 0–100. Bold + colored above thresholds; muted otherwise.
 * Uses tabular-nums so columns line up vertically across rows.
 */
export function ScoreCell({ score }: { score: number }) {
  const tone =
    score >= 80
      ? 'text-status-failed font-semibold'
      : score >= 60
        ? 'text-status-pending font-medium'
        : 'text-fg'
  return <span className={cn('font-mono tabular-nums text-sm', tone)}>{score}</span>
}
